const  BLOG_CATEGORIES = [
  {
    "category": "HEALTH",
    "subcategories": [
      {
        "name": "Medical News",
        "tags": [
          "Health Policies",
          "Medical Research",
          "Public Health Alerts",
          "Disease Outbreaks"
        ]
      },
      {
        "name": "Fitness & Wellness",
        "tags": [
          "Workout Plans",
          "Weight Loss",
          "Yoga & Meditation",
          "Mental Wellness"
        ]
      },
      {
        "name": "Nutrition",
        "tags": [
          "Diet Trends",
          "Superfoods",
          "Expert Advice",
          "Healthy Recipes"
        ],
        "meta": {
          "expert": "Nishant Verma"
        }
      },
      {
        "name": "Specialized Health",
        "tags": [
          "Women’s Health",
          "Men’s Health",
          "Child Health",
          "Senior Care"
        ]
      },
      {
        "name": "Lifestyle Diseases",
        "tags": [
          "Diabetes",
          "Heart Health",
          "Obesity",
          "Stress Disorders"
        ]
      }
    ]
  },

  {
    "category": "REAL ESTATE",
    "subcategories": [
      {
        "name": "Property News",
        "tags": [
          "Market Trends",
          "Latest Policy Updates",
          "Government Schemes",
          "Infrastructure Developments"
        ]
      },
      {
        "name": "Buying & Selling",
        "tags": [
          "First-Time Buyers",
          "Legal Guide",
          "Home Loans",
          "Property Valuation"
        ]
      },
      {
        "name": "Investment",
        "tags": [
          "Commercial Real Estate",
          "Residential Investment",
          "REITs",
          "Rental Income",
          "Under Construction"
        ]
      },
      {
        "name": "Home & Living",
        "tags": [
          "Interior Design",
          "Home Improvement",
          "Smart Homes",
          "Vastu",
          "Feng Shui",
          "Architecture",
          "Office Designs"
        ]
      }
    ]
  },

  {
    "category": "FASHION & LIFESTYLE",
    "subcategories": [
      {
        "name": "Fashion",
        "tags": [
          "Latest Trends",
          "Celebrity Style",
          "Designer Spotlight",
          "Sustainable Fashion"
        ]
      },
      {
        "name": "Beauty",
        "tags": [
          "Skincare",
          "Makeup",
          "Haircare",
          "Product Reviews"
        ]
      },
      {
        "name": "Lifestyle",
        "tags": [
          "Relationships",
          "Personal Growth",
          "Luxury Living",
          "Work-Life Balance"
        ]
      },
      {
        "name": "Travel",
        "tags": [
          "Travel News",
          "Destination Guides",
          "Budget Travel",
          "Luxury Travel"
        ]
      }
    ]
  },

  {
    "category": "NEWS",
    "subcategories": [
      {
        "name": "National",
        "tags": [
          "Politics",
          "Government Policies",
          "Economy",
          "Social Issues"
        ]
      },
      {
        "name": "International",
        "tags": [
          "Global Politics",
          "World Economy",
          "Diplomacy"
        ]
      },
      {
        "name": "Business",
        "tags": [
          "Stock Market",
          "Startups",
          "Corporate News",
          "Cryptocurrency"
        ]
      },
      {
        "name": "Technology",
        "tags": [
          "AI & Innovation",
          "Gadgets",
          "Cybersecurity",
          "Apps & Software"
        ]
      },
      {
        "name": "Entertainment",
        "tags": [
          "Movies",
          "OTT",
          "Celebrity News",
          "Music"
        ]
      },
      {
        "name": "Breaking News",
        "tags": [
          "Live Updates",
          "Trending Stories"
        ]
      }
    ]
  },

  {
    "category": "POLITICS",
    "subcategories": [
      {
        "name": "National Politics",
        "tags": [
          "Government Policies Updates",
          "Parliament Updates",
          "Political Parties",
          "Election News",
          "Political Debates"
        ]
      },
      {
        "name": "International Politics",
        "tags": [
          "Global Diplomacy",
          "Foreign Relations",
          "International Conflicts",
          "Trade Agreements",
          "Global Summits"
        ]
      },
      {
        "name": "Elections",
        "tags": [
          "Election Campaigns",
          "Opinion Polls",
          "Exit Polls",
          "Election Results",
          "Candidate Profiles"
        ]
      },
      {
        "name": "Political Analysis",
        "tags": [
          "Policy Analysis",
          "Political Strategy",
          "Ideologies",
          "Power Shifts",
          "Explainers"
        ]
      },
      {
        "name": "Governance & Public Policy",
        "tags": [
          "Bills & Laws",
          "Constitutional Matters",
          "Supreme Court",
          "Public Administration",
          "Bureaucracy"
        ]
      },
      {
        "name": "Political Interviews",
        "tags": [
          "Leader Interviews",
          "Expert Opinions",
          "Ground Reports"
        ]
      },
      {
        "name": "State / Regional Politics",
        "tags": [
          "State Government",
          "Local Governance",
          "Municipal News",
          "Regional Party Updates"
        ]
      }
    ]
  },

  {
    "category": "OTHER",
    "subcategories": [
      {
        "name": "Education",
        "tags": [
          "Policy Updates",
          "Exams & Results",
          "Career Guidance",
          "Scholarships",
          "Online Learning",
          "Study Tips"
        ]
      },
      {
        "name": "Environment",
        "tags": [
          "Climate Change",
          "Environmental Policies",
          "Sustainability",
          "Natural Disasters"
        ]
      },
      {
        "name": "Law & Order",
        "tags": [
          "Crime Reports",
          "Legal News",
          "Court Cases",
          "Public Safety"
        ]
      },
      {
        "name": "Science",
        "tags": [
          "Space News",
          "Scientific Discoveries",
          "Research Updates"
        ]
      },
      {
        "name": "Social Issues",
        "tags": [
          "Human Rights",
          "Gender Issues",
          "Public Awareness",
          "Social Movements"
        ]
      },
      {
        "name": "Trending Topics",
        "tags": [
          "Viral News",
          "Social Media Trends",
          "Public Reactions"
        ]
      },
      {
        "name": "Finance",
        "tags": [
          "Personal Finance",
          "Saving & Investing",
          "Side Hustles",
          "Passive Income"
        ]
      },
      {
        "name": "Automotive",
        "tags": [
          "Car Reviews",
          "Maintenance Tips",
          "EV News",
          "Bikes and Scooters"
        ]
      },
      {
        "name": "Food & Recipes",
        "tags": [
          "Quick Meals",
          "Desserts",
          "International Cuisine",
          "Indian Cuisine"
        ]
      }
    ]
  }
];

export default BLOG_CATEGORIES;































// const BLOG_CATEGORIES = [
//   {
//     category: "HEALTH",
//     subcategories: [
//       { name: "Medical News" },
//       { name: "Fitness & Wellness" },
//       {
//         name: "Nutrition",
//         meta: { expert: "Nishant Verma" }
//       },
//       { name: "Specialized Health" },
//       { name: "Lifestyle Diseases" }
//     ]
//   },

//   {
//     category: "REAL ESTATE",
//     subcategories: [
//       { name: "Property News" },
//       { name: "Buying & Selling" },
//       { name: "Investment" },
//       { name: "Home & Living" }
//     ]
//   },

//   {
//     category: "FASHION & LIFESTYLE",
//     subcategories: [
//       { name: "Fashion" },
//       { name: "Beauty" },
//       { name: "Lifestyle" },
//       { name: "Travel" }
//     ]
//   },

//   {
//     category: "NEWS",
//     subcategories: [
//       { name: "National" },
//       { name: "International" },
//       { name: "Business" },
//       { name: "Technology" },
//       { name: "Entertainment" },
//       { name: "Breaking News" }
//     ]
//   },

//   {
//     category: "POLITICS",
//     subcategories: [
//       { name: "National Politics" },
//       { name: "International Politics" },
//       { name: "Elections" },
//       { name: "Political Analysis" },
//       { name: "Governance & Public Policy" },
//       { name: "Political Interviews" },
//       { name: "State / Regional Politics" }
//     ]
//   },

//   {
//     category: "OTHER",
//     subcategories: [
//       { name: "Education" },
//       { name: "Environment" },
//       { name: "Law & Order" },
//       { name: "Science" },
//       { name: "Social Issues" },
//       { name: "Trending Topics" },
//       { name: "Finance" },
//       { name: "Automotive" },
//       { name: "Food & Recipes" }
//     ]
//   },
//    {
//     category: "FEATURED",
//     subcategories: [
//       { name: "Latest" },
      
//     ]
//   }
// ];

// export default BLOG_CATEGORIES;